var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-full-bg line-liff-detail liff-line-font-size-18",domProps:{"innerHTML":_vm._s(_vm.title)},on:{"click":function($event){return _vm.clickBtn()}}})}
var staticRenderFns = []

export { render, staticRenderFns }